import { PRODUCT_DISCOVERY, SERVICE_DESK, SOFTWARE } from '@atlassian/jira-shared-types';

export const JSW_CCP_MANUAL_UPGRADE_TRAIT =
	'jira-software-billing-console_track_upgrade_success_client_first';
export const JSW_HAMS_MANUAL_UPGRADE_TRAIT =
	'jira-software-admin_track_upgrade_success_client_first';
export const JSM_CCP_MANUAL_UPGRADE_TRAIT =
	'jira-servicemanagement-billing-console_track_upgrade_success_client_first';
export const JSM_HAMS_MANUAL_UPGRADE_TRAIT =
	'jira-servicemanagement-admin_track_upgrade_success_client_first';
export const JPD_CCP_MANUAL_UPGRADE_TRAIT =
	'jira-product-discovery_track_upgrade_success_client_first';
export const JPD_AUTO_UPGRADE_TRAIT =
	'jira-product-discovery_operational_upgrade_success_auto_upgrade_server_first';
export const JSM_AUTO_UPGRADE_TRAIT =
	'jira-servicemanagement_operational_upgrade_success_auto_upgrade_server_first';
export const JSW_AUTO_UPGRADE_TRAIT =
	'jira-software_operational_upgrade_success_auto_upgrade_server_first';

export const UPGRADE_ONBOARDING_PRODUCT_TRAIT_MAP = new Map(
	Object.entries({
		[SOFTWARE]: [
			JSW_CCP_MANUAL_UPGRADE_TRAIT,
			JSW_HAMS_MANUAL_UPGRADE_TRAIT,
			JSW_AUTO_UPGRADE_TRAIT,
		],
		[SERVICE_DESK]: [
			JSM_CCP_MANUAL_UPGRADE_TRAIT,
			JSM_HAMS_MANUAL_UPGRADE_TRAIT,
			JSM_AUTO_UPGRADE_TRAIT,
		],
		[PRODUCT_DISCOVERY]: [JPD_CCP_MANUAL_UPGRADE_TRAIT, JPD_AUTO_UPGRADE_TRAIT],
	}),
);
